var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M43,2v22c0,2.209,1.791,4,4,4s4-1.791,4-4V2H43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M23,24c0,2.209,1.791,4,4,4s4-1.791,4-4V2h-8V24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M3,4v20c0,2.209,1.791,4,4,4s4-1.791,4-4V2H5C3.896,2,3,2.895,3,4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBB2",
    d: "M58,60c0,1.104-0.896,2-2,2H26V37c0-0.516-0.447-1-1-1H11c-0.553,0-1,0.447-1,1v25H8c-1.104,0-2-0.896-2-2 V29.91C6.326,29.965,6.658,30,7,30c2.088,0,3.926-1.068,5-2.688C13.074,28.932,14.912,30,17,30s3.926-1.068,5-2.688 C23.074,28.932,24.912,30,27,30s3.926-1.068,5-2.688C33.074,28.932,34.912,30,37,30s3.926-1.068,5-2.688 C43.074,28.932,44.912,30,47,30s3.926-1.068,5-2.688C53.074,28.932,54.912,30,57,30c0.342,0,0.674-0.035,1-0.09V60z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M33,24c0,2.209,1.791,4,4,4s4-1.791,4-4V2h-8V24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M13,24c0,2.209,1.791,4,4,4s4-1.791,4-4V2h-8V24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M59,2h-6v22c0,2.209,1.791,4,4,4s4-1.791,4-4V4C61,2.895,60.104,2,59,2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M59,0H5C2.789,0,1,1.789,1,4v20c0,2.219,1.208,4.152,3,5.189V60c0,2.211,1.789,4,4,4h48 c2.211,0,4-1.789,4-4V29.189c1.792-1.037,3-2.971,3-5.189V4C63,1.789,61.211,0,59,0z M51,2v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V2 H51z M41,2v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V2H41z M31,2v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V2H31z M21,2v22 c0,2.209-1.791,4-4,4s-4-1.791-4-4V2H21z M3,4c0-1.105,0.896-2,2-2h6v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V4z M12,62V38h12v10h-1 c-0.553,0-1,0.447-1,1s0.447,1,1,1h1v12H12z M58,60c0,1.104-0.896,2-2,2H26V37c0-0.516-0.447-1-1-1H11c-0.553,0-1,0.447-1,1v25H8 c-1.104,0-2-0.896-2-2V29.91C6.326,29.965,6.658,30,7,30c2.088,0,3.926-1.068,5-2.688C13.074,28.932,14.912,30,17,30 s3.926-1.068,5-2.688C23.074,28.932,24.912,30,27,30s3.926-1.068,5-2.688C33.074,28.932,34.912,30,37,30s3.926-1.068,5-2.688 C43.074,28.932,44.912,30,47,30s3.926-1.068,5-2.688C53.074,28.932,54.912,30,57,30c0.342,0,0.674-0.035,1-0.09V60z M57,28 c-2.209,0-4-1.791-4-4V2h6c1.104,0,2,0.895,2,2v20C61,26.209,59.209,28,57,28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M53,36H29c-0.553,0-1,0.447-1,1v20c0,0.553,0.447,1,1,1h24c0.553,0,1-0.447,1-1V37 C54,36.447,53.553,36,53,36z M52,56H30V38h22V56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#45AAB8",
    d: "M12,62h12V50h-1c-0.553,0-1-0.447-1-1s0.447-1,1-1h1V38H12V62z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 38,
    fill: "#45AAB8",
    width: 22,
    height: 18
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M48.293,42.707C48.488,42.902,48.744,43,49,43s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414 l-1-1c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L48.293,42.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M48.293,47.707C48.488,47.902,48.744,48,49,48s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414 l-6-6c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L48.293,47.707z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineShop);
export default __webpack_public_path__ + "static/media/online-shop.420a00c8639922b3b84eb21de08e6f09.svg";
export { ForwardRef as ReactComponent };